export function getAcademyModuleEntry(child: any) {
  const oneToOne = child?.modules?.ONE_TO_ONE;
  if (!oneToOne) return null;

  if (oneToOne.academyProgramVariant) return oneToOne.academyProgramVariant;
  if (oneToOne.academy_program_variant) return oneToOne.academy_program_variant;

  for (const key of Object.keys(oneToOne)) {
    const entry = oneToOne[key];
    if (entry?.model === "academyProgramVariant") return entry;
  }

  return null;
}

export function useAcademyChildModuleData(child: any) {
  const variantEntry = getAcademyModuleEntry(child);

  const programName =
    variantEntry?.program?.value || variantEntry?.academyProgram?.value || "";
  const variantName = variantEntry?.value || "";
  const variantId = variantEntry?.id ?? null;

  return {
    programName,
    variantName,
    variantId,
  };
}
